// @core/api/endpoints/platform/get_federation_peer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FederationPeerResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get federation peer
 * Retrieves detailed information about a federation peer connection including status, sync config, and health.
 */
export async function GetFederationPeer(
  peer_id: string,
  options?: RequestOptions
): Promise<FederationPeerResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/federation/peers/:peer_id`;
  requestPath = requestPath.replace(':peer_id', encodeURIComponent(peer_id));
  const requestOptions = options;
  return client.get<FederationPeerResponse>(requestPath, { ...requestOptions });
}
